import classNames from 'classnames'

export default function Card({ children, className = '', withGradient = false }) {
  return (
    <div className={classNames(
      'rounded-[26px] flex',
      { 'pt-[1px] bg-[linear-gradient(90deg,#FFFFFF_0%,#639DFF_50%,#FFFFFF_100%)] dark:bg-[linear-gradient(90deg,rgba(25,220,161,0)_0%,#43FFC6_47.5%,rgba(13,118,86,0)_100%)]': withGradient },
      className
    )}>
      <div className={classNames(
        'border-t-[1px] border-b-[1px] dark:border-[#43FFC620]',
        'flex-1 flex bg-background flex-col items-center justify-center shadow-[0px_0px_4px_0px_#0000001A] rounded-[26px] gap-4 py-6',
        { 'bg-[linear-gradient(180deg,_rgba(99,157,255,0.1)_0%,_rgba(255,255,255,0)_100%)] dark:bg-[linear-gradient(180deg,_rgba(30,242,178,0.1)_0%,_rgba(0,0,0,0)_45%)]': withGradient },
      )}>
        {children}
      </div>
    </div>
  )
}